import { render } from "./ReihenhausStep1.vue?vue&type=template&id=e196edc2&scoped=true"
import script from "./ReihenhausStep1.vue?vue&type=script&lang=js"
export * from "./ReihenhausStep1.vue?vue&type=script&lang=js"

import "./ReihenhausStep1.vue?vue&type=style&index=0&id=e196edc2&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e196edc2"]])

export default __exports__